<template>
    <footer>
        <slot></slot>
    </footer>
</template>

<script>
    export default {
        
    }
</script>

<style lang="css" scoped>

footer {
  position:fixed; 
  bottom:0; 
  left:0px; 
  right:0px; 
  overflow:hidden;
  padding: 0.5rem 5% 2.214rem;
  background: var(--main-white);
  
}
  @media (min-width: 600px) and (max-width: 800px) {
    footer {
        padding: 1rem 10% 2.214rem;
    }
  }
  @media (min-width: 800px) and (max-width: 999px) {
    footer{
        padding: 1rem 25% 2.214rem;
    }
  }
  @media (min-width: 1000px) {
    footer{
        padding: 1rem 25% 2.214rem;
    }
  }
  div {
    padding: 0.8rem 0;
    text-transform: uppercase;
  
}
</style>